/* eslint-disable import/prefer-default-export */
import styled, { css } from 'styled-components';
import { Button, Icon } from '@fnacdarty/back-office-ui';

export const StyledButton = styled(Button)`
	height: 36px;
	&:not(:last-child) {
		margin-bottom: 0;
	}
`;
export const StyledIcon = styled(Icon)`
	position: absolute;
	float: right;
	margin-left: 160px;
`;
export const DropDownContainer = styled.div`
	width: 12.3em;
	margin: 0 auto;
`;
export const DropDownHeader = styled.div`
	cursor: pointer;
	padding: 0.4em 2em 0.4em 1em;
	box-shadow: 0 2px 3px rgba(0, 0, 0, 0.15);
	font-weight: 500;
	color: white;
	background: rgb(2 62 138);
	border-radius: 5px;
	border: 1px solid rgb(2 62 138);
	text-align: center;
	font-size: 16px;
	width: 100%;
`;
export const DropDownListContainer = styled.div`
	position: fixed;
	z-index: 4;
	${(props) =>
		props.showicon &&
		css`
			bottom: 0;
			right: 0;
			margin-bottom: 100px;
			margin-right: 45px;
		`}
`;
export const DropDownList = styled.ul`
	padding: 0;
	margin: 0;
	padding-left: 0;
	background: white;
	border: 2px solid #e5e5e5;
	box-sizing: border-box;
	color: black;
	font-size: 16px;
	font-weight: 300;
	width: 12.3em;
	border-radius: 5px;
`;
export const ListItem = styled.li`
	display: flex;
	-webkit-box-align: center;
	align-items: center;
	-webkit-box-pack: center;
	justify-content: center;
	width: 100%;
	height: 50px;
	padding: 5px;
	border-radius: 5px;
	cursor: pointer;
	background-color: rgb(255, 255, 255);
	&:hover,
	&:focus {
		background-color: rgb(184, 203, 242);
	}
`;
export const DropdownHeaderIcon = styled.div`
	cursor: pointer;
	float: right;
	margin-right: 25px;
	.CircleButtonClass {
		@media (max-width: ${({ theme }) => theme.breakpoints.lg}) {
			position: fixed;
			bottom: 0;
			right: 0;
			margin-bottom: 70px;
			margin-right: 20px;
		}
	}
`;
